import { init } from '@dash0/sdk-web';

/**
 * Dash0 RUM (real user monitoring) initialization for entry-hall.
 */

// [0, 100] Percentage of sessions to record, per environment.
const SESSION_SAMPLING_RATE_BY_ENV: Record<string, number> = {
    development: 0,
    staging: 10,
    production: 100,
};

export function initDash0(environment?: string): void {
    const endpoint = process.env.DASH0_ENDPOINT_URL;
    const authToken = process.env.DASH0_AUTH_TOKEN;

    if (!endpoint || !authToken) {
        return;
    }

    const release = process.env.RELEASE;

    init({
        serviceName: 'entry-hall',
        environment,
        serviceVersion: release,
        deploymentName: 'main',
        deploymentId: release || 'local',
        endpoint: { url: endpoint, authToken },
        sessionSamplingRate:
            SESSION_SAMPLING_RATE_BY_ENV[environment ?? ''] ?? 0,
    });
}
